import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const attempts = useRef(0);
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); refreshUser(); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setState("error"); return; }
      } catch { /* retry */ }
      if (attempts.current >= 8) { setState("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, refreshUser]);

  return (
    <div className="mx-auto max-w-md card-surface p-10 text-center fade-up" data-testid="payment-success-page">
      {state === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-emerald-400" /><h1 className="mt-4 font-heading text-xl font-bold">Ödeme doğrulanıyor…</h1><p className="mt-2 text-sm text-slate-400">Birkaç saniye sürebilir.</p></>}
      {state === "paid" && <><CheckCircle2 className="mx-auto h-12 w-12 text-emerald-400" /><h1 className="mt-4 font-heading text-2xl font-bold" data-testid="payment-success-title">Paketin aktif!</h1><p className="mt-2 text-sm text-slate-400">Günlük tarama ve sabah e-postası açıldı. İyi avlar.</p><Link to="/" data-testid="payment-success-dashboard-link" className="mt-6 inline-block rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-semibold text-[#0A0D14] hover:bg-emerald-400">Panoya dön</Link></>}
      {state === "timeout" && <><Loader2 className="mx-auto h-10 w-10 text-amber-400" /><h1 className="mt-4 font-heading text-xl font-bold">Doğrulama uzun sürdü</h1><p className="mt-2 text-sm text-slate-400">Ödeme alındıysa paketin birkaç dakika içinde açılır. Profil → Üyeliğim'den kontrol edebilirsin.</p><Link to="/profile" className="mt-6 inline-block text-sm text-cyan-300 hover:underline">Üyeliğime git</Link></>}
      {state === "error" && <><XCircle className="mx-auto h-12 w-12 text-rose-400" /><h1 className="mt-4 font-heading text-xl font-bold">Ödeme tamamlanamadı</h1><Link to="/pricing" className="mt-6 inline-block text-sm text-cyan-300 hover:underline">Paketlere dön</Link></>}
    </div>
  );
}

export function PaymentCancelPage() {
  return (
    <div className="mx-auto max-w-md card-surface p-10 text-center fade-up" data-testid="payment-cancel-page">
      <XCircle className="mx-auto h-12 w-12 text-slate-400" />
      <h1 className="mt-4 font-heading text-xl font-bold">Ödeme iptal edildi</h1>
      <p className="mt-2 text-sm text-slate-400">Ücretsiz pakette devam ediyorsun. İstediğin zaman yükseltebilirsin.</p>
      <Link to="/pricing" data-testid="payment-cancel-pricing-link" className="mt-6 inline-block rounded-full border border-white/10 px-5 py-2.5 text-sm hover:bg-white/5">Paketlere dön</Link>
    </div>
  );
}
